module.exports = __webpack_public_path__ + "static/media/toggle-up.bf1838cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/toggle-up.svg
// module id = 718
// module chunks = 0